import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Bell, Calendar, Heart, Star, MapPin, Shield, Music } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'
import { ErrorBoundary } from './ErrorBoundary'
import styles from './AppLayout.module.css'

type TabKey = 'home' | 'calendar' | 'tickets' | 'people' | 'artists' | 'you'

const tabs: { key: TabKey; label: string; Icon: React.FC<{ size?: number; color?: string }> }[] = [
  { key: 'home', label: 'Home', Icon: Star },
  { key: 'calendar', label: 'Calendar', Icon: Calendar },
  { key: 'tickets', label: 'Tickets', Icon: MapPin },
  { key: 'people', label: 'People', Icon: Heart },
  { key: 'artists', label: 'Artists', Icon: Music },
  { key: 'you', label: 'You', Icon: Shield },
]

export function AppLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const { theme, toggleTheme } = useTheme()

  const activeTab: TabKey = ((): TabKey => {
    const p = location.pathname.replace('/', '') || 'home'
    return tabs.find(t => t.key === p)?.key ?? 'home'
  })()

  return (
    <div className={styles.app}>
      {/* App bar */}
      <div className={styles.appBar}>
        <div className={styles.brand}>
          OnIsland{' '}
          <span className={styles.subtitle}>· the island</span>
        </div>
        <button className={styles.iconBtn} onClick={toggleTheme} title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
          <Bell size={18} />
        </button>
        <button className={styles.primaryBtn}>
          <Star size={18} />
        </button>
      </div>

      {/* Screen area */}
      <div className={styles.screen}>
        <ErrorBoundary key={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </div>

      {/* Bottom tab bar */}
      <div className={styles.tabBar}>
        {tabs.map((tab) => {
          const isActive = tab.key === activeTab
          const Icon = tab.Icon
          return (
            <button
              key={tab.key}
              className={`${styles.tab} ${isActive ? styles.active : ''}`}
              onClick={() => navigate(tab.key === 'home' ? '/' : `/${tab.key}`)}
            >
              <Icon size={22} color={isActive ? '#ec3013' : 'currentColor'} />
              <span>{tab.label}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
